import styled from 'styled-components';
import { Type } from '../../theme/types'

export const DescriptionText = styled.p`
  ${({ theme }: Type) => theme?.inputAgegate?.description}
`
export const SpanPolitics = styled.span`
  ${({ theme }: Type) => theme?.agegate?.spanPolitics}
`